<div class="kt-container  kt-grid__item kt-grid__item--fluid">

    <!--Begin::App-->
    <div class="kt-grid kt-grid--desktop kt-grid--ver kt-grid--ver-desktop kt-app">

        <!--Begin:: App Aside Mobile Toggle-->
        <button class="kt-app__aside-close" id="kt_user_profile_aside_close">
            <i class="la la-close"></i>
        </button>

        <!--End:: App Aside Mobile Toggle-->

        <!--Begin:: App Aside-->
        <div class="kt-grid__item kt-app__toggle kt-app__aside" id="kt_user_profile_aside">

            <!--begin:: Widgets/Applications/User/Profile4-->
            <div class="kt-portlet kt-portlet--height-fluid-">
                <div class="kt-portlet__body">

                    <!--begin::Widget -->
                    <div class="kt-widget kt-widget--user-profile-4">
                        <div class="kt-widget__head">
                            <div class="kt-widget__media">
                                <img class="kt-widget__img kt-hidden-" *ngIf="isImage" src="{{assetsPath + userBasicInfo.image}}" alt="image">
                                <img class="kt-widget__img kt-hidden-" *ngIf="!isImage" src="/assets/media/users/default.jpg" alt="image">
                                <div
                                    class="kt-widget__pic kt-widget__pic--danger kt-font-danger kt-font-boldest kt-font-light kt-hidden">
                                    AD
                                </div>
                            </div>
                            <div class="kt-widget__content">
                                <div class="kt-widget__section">
                                    <a href="#" class="kt-widget__username">
                                        {{ userBasicInfo.displayName}}
                                    </a>
                                    <div class="kt-widget__button">
                                        <span class="btn btn-label-warning btn-sm">Aktif Gönüllü</span> <br *ngIf="userBasicInfo.isAlumni"><br *ngIf="userBasicInfo.isAlumni">
                                        <span class="btn btn-label-brand btn-sm" *ngIf="userBasicInfo.isAlumni">Mezun</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="kt-widget__body">
                            <a [routerLink]="['/my-profile']" class="kt-widget__item">
                                Genel Bilgiler
                            </a>
                            <a [routerLink]="['/update-my-basic-information']"
                                class="kt-widget__item kt-widget__item--active">
                                Temel Bilgilerimi Güncelle
                            </a>
                            <a [routerLink]="['/update-my-role-settings']" class="kt-widget__item">
                                Gönüllülük Alanlarım
                            </a>
                            <a [routerLink]="['/update-my-password']" class="kt-widget__item">
                                Şifremi Değiştir
                            </a>
                            <a [routerLink]="['/my-profession-list']" class="kt-widget__item">
                                Kariyer Bilgilerim
                            </a>
                            <a [routerLink]="['/my-education-list']" class="kt-widget__item">
                                Eğitim Bilgilerim
                            </a>
                            <a [routerLink]="['/judge-form']" class="kt-widget__item">
                                Jürilik Bilgi Formu
                            </a>
                            <a [routerLink]="['/referee-form']" class="kt-widget__item">
                                Hakemlik Bilgi Formu
                            </a>
                        </div>
                    </div>

                    <!--end::Widget -->
                </div>
            </div>

            <!--end:: Widgets/Applications/User/Profile4-->

            <!--Begin:: Portlet-->
            <div class="kt-portlet">
                <div class="kt-portlet__body">
                    <div class="kt-widget1 kt-widget1--fit">
                        <div class="kt-widget1__item">
                            <div class="kt-widget1__info">
                                <h3 class="kt-widget1__title">Başvurularım</h3>
                                <span class="kt-widget1__desc">Aktif başvuru sayısı</span>
                            </div>
                            <span class="kt-widget1__number kt-font-brand">0</span>
                        </div>
                        <div class="kt-widget1__item">
                            <div class="kt-widget1__info">
                                <h3 class="kt-widget1__title">Rozetlerim</h3>
                                <span class="kt-widget1__desc">Rozet sayısı</span>
                            </div>
                            <span class="kt-widget1__number kt-font-success">0</span>
                        </div>
                    </div>
                </div>
            </div>

            <!--end:: Portlet-->
        </div>

        <!--End:: App Aside-->

        <!--Begin:: App Content-->
        <div class="kt-grid__item kt-grid__item--fluid kt-app__content">
            <div class="row">
                <div class="col-xl-12">
                    <div class="kt-portlet">
                        <div class="kt-portlet__head">
                            <div class="kt-portlet__head-label">
                                <h3 class="kt-portlet__head-title">Bilgilerimi Güncelle</h3>
                            </div>
                        </div>
                        <form [formGroup]="updateMyUserForm" (ngSubmit)="update()" class="kt_login_form">
                            <div class="kt-portlet__body">
                                <div class="kt-section kt-section--first">
                                    <div class="kt-section__body">
                                        <div class="row">
                                            <div class="col-lg-9 col-xl-6">
                                                <h3 class="kt-section__title kt-section__title-sm">Bilgilerimi Güncelle:
                                                </h3>
                                            </div>
                                        </div>
                                        <!-- <div class="form-group row">
                                            <label class="col-form-label">Ad soyad</label>

                                            <input formControlName="fullName" type="text" class="form-control"
                                                placeholder="Ad soyad">
                                            <small class="form-text text-warning"
                                                *ngIf="f.fullName.errors?.required">Lütfen ad soyad giriniz!</small>
                                            <small class="form-text text-warning"
                                                *ngIf="f.fullName.errors?.minlength">Lütfen en az
                                                5 en fazla 100 haneli bir isim giriniz!</small>
                                            <small class="form-text text-warning"
                                                *ngIf="f.fullName.errors?.maxlength">Lütfen en az
                                                5 en fazla 100 haneli bir isim giriniz!</small>

                                        </div> -->
                                        <div class="form-group row">
                                            <label class="col-form-label">Telefon</label>

                                            <input formControlName="phone" type="text" class="form-control"
                                                placeholder="Telefon">
                                            <small class="form-text text-warning"
                                                *ngIf="f.phone.errors?.required">Lütfen telefon numaranızı
                                                giriniz!</small>
                                            <small class="form-text text-warning"
                                                *ngIf="f.phone.errors?.minlength">Lütfen 10 haneli (5XXXXXXXXX)
                                                telefon numaranızı giriniz!</small>
                                            <small class="form-text text-warning"
                                                *ngIf="f.phone.errors?.maxlength">Lütfen 10 haneli (5XXXXXXXXX)
                                                telefon numaranızı giriniz!</small>
                                        </div>

                                        <div class="form-group row">
                                            <label class="col-form-label">Birincil şehir</label>

                                            <ng-select
                                                bindValue="id" style="width: 100%; padding: 5px; float: left;clear: both;"
                                                placeholder="Şehir" [items]="cities" bindLabel="name"
                                                formControlName="primaryCityId">
                                            </ng-select>
                                            <small class="form-text text-warning"
                                                *ngIf="f.primaryCityId.errors?.required">Lütfen birincil şehrinizi
                                                seçiniz!</small>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-form-label">İkincil şehir</label>

                                            <ng-select
                                                bindValue="id" style="width: 100%; padding: 5px; float: left;clear: both;"
                                                placeholder="Şehir" [items]="cities" bindLabel="name"
                                                formControlName="secondaryCityId">
                                            </ng-select>
                                            <!-- <small class="form-text text-warning"
                                                *ngIf="f.secondaryCityId.errors?.required">Lütfen ikincil şehrinizi
                                                seçiniz!</small> -->
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-form-label">Profil resmi</label>
                                            <ngx-file-drop dropZoneLabel="Dosyaları buraya sürükleyin" style="width: 100%;"
                                                (onFileDrop)="onLocalFileChange($event)"
                                                dropZoneClassName="custom-dropzone">
                                                <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                                                    Dosyayı buraya sürükle veya
                                                    <button type="button" class="btn btn-outline-info ml-3"
                                                        (click)="openFileSelector()">Dosya
                                                        seç</button>
                                                </ng-template>
                                            </ngx-file-drop>
                                            <ng-container *ngIf="updateModel.image">
                                                <div class="files-container">
                                                    <div class="file-container">
                                                        <img class="file-image"
                                                            [src]="assetsPath + updateModel.image">
                                                            <a href="{{assetsPath + updateModel.image}}" target="_blank"><span class="file-name">{{updateModel.image}}</span></a>
                                                        <button class="btn btn-danger btn-sm"
                                                            (click)="removeFile()"><i class="fa fa-trash"></i>
                                                            Kaldır</button>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="kt-portlet__foot">
                                <div class="kt-form__actions">
                                    <div class="row">
                                        <div class="col-lg-9 col-xl-9">
                                            <button type="submit" class="btn btn-success btn-bold">Güncelle</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!--End:: App Content-->
    </div>

    <!--End::App-->
</div>